import { api } from "src/Basic/ApiFetch";
import { showGlobalMessageBox, getGlobalServerConfig } from "src/Route/RootMiddleware";
import { SetMaskOnOff } from "src/Basic/SDOExtension";

const baseUrl = getGlobalServerConfig().backEndUrl.get();

//取得個資聲明內容
export const getPIContent = async (path, setItem, setType) => {
    let url = baseUrl + path + '/' + setItem + '/' + setType;
    SetMaskOnOff(true);
    let response = await api.Get(url, null, null, false);
    let result = {};
    if (response.ok) {
        result = await response.json();
        // 檢查結果是否有值
        if (!result || Object.keys(result).length === 0) {
            showGlobalMessageBox("系統發生錯誤請聯繫管理員");
        }
    }
    SetMaskOnOff(false);
    return result;
};
//取得注意事項內容
export const getNContent = async (setItem, memo) => {
    let url = baseUrl + 'SetParam/GetParamByItemAndMemo/' + setItem + '/' + memo;
    SetMaskOnOff(true);
    let response = await api.Get(url, null, null, false);
    let result = {};
    if (response.ok) {
        result = await response.json();

        // 檢查結果是否有值
        if (!result) {
            showGlobalMessageBox("系統發生錯誤請聯繫管理員");
        }
    }
    SetMaskOnOff(false);
    return result;
};


/**
 * 檢查指定 email 是否為特權帳號（MaintainAccounts）
 * @param {string} email 要判斷的使用者 email
 * @returns {Promise<boolean>} true = 是特權帳號
 */
export const isMaintainAccounts = async (email) => {
    let url = baseUrl + 'ProjectCommon/IsMaintainAccounts';
    let response = await api.Post(url, JSON.stringify(email), null, true);
    let result = false;
    if (response.ok) {
        result = await response.json();
    }
    return result;
}
